export function parseISO(iso) {
  return new Date(iso + "T00:00:00");
}

export function formatDate(iso) {
  if (!iso) return "";
  return parseISO(iso).toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
}

export function longDate(iso) {
  if (!iso) return "";
  return parseISO(iso).toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" });
}

export function dayNum(iso) {
  return parseISO(iso).getDate();
}

export function monthAbbr(iso) {
  return parseISO(iso).toLocaleDateString(undefined, { month: "short" }).toUpperCase();
}

export function formatTime(t) {
  if (!t) return "";
  const [hStr, m] = t.split(":");
  let h = parseInt(hStr, 10);
  if (isNaN(h)) return t;
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h}:${m} ${ampm}`;
}

export function formatClockTime(input) {
  if (!input) return "";
  const d = new Date(input);
  if (isNaN(d.getTime())) return typeof input === "string" ? input : "";
  return d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
}

export function todayISO() {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

// Quick-view range bounds (inclusive ISO date strings) for Today / This week /
// This month. Returns null for "all". Week starts on Sunday to match the grid.
export function rangeBounds(range) {
  const now = new Date();
  const p = (n) => String(n).padStart(2, "0");
  const iso = (d) => `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
  if (range === "today") { const s = iso(now); return { start: s, end: s }; }
  if (range === "week") {
    const start = new Date(now); start.setDate(now.getDate() - now.getDay());
    const end = new Date(start); end.setDate(start.getDate() + 6);
    return { start: iso(start), end: iso(end) };
  }
  if (range === "month") {
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    return { start: iso(start), end: iso(end) };
  }
  return null;
}

export function inRange(dateStr, bounds) {
  if (!bounds) return true;
  return dateStr >= bounds.start && dateStr <= bounds.end;
}

export function commentTime(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
  } catch {
    return "";
  }
}

export function photoDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return "";
  }
}
